// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPlayer__container__iI4zO","fullSize":"VideoPlayer__fullSize__RN8Up"};